import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogoListItem from '@/components/Menu/components/Logo/Logo.vue'
import UserListItem from '@/components/Menu/components/User/User.vue'
import ProjectListItem from '@/components/Menu/components/Project/Project.vue'
import SignOutListItem from '@/components/Menu/components/SignOut/SignOut.vue'
import SubitemMenu from '@/components/Menu/components/Subitem/Subitem.vue'
import Language from '@/components/Menu/components/language/language.vue'
import LanguageMenu from '@/views/Language/components/menu/menu.vue'
import MenuMixin from '@/_mixins/menu'

@Component({
    mixins: [MenuMixin],
    components: {
        LogoListItem,
        UserListItem,
        ProjectListItem,
        SignOutListItem,
        SubitemMenu,
        Language,
        LanguageMenu,
    },
})
export default class Menu extends Mixins<MixinInterface & MenuMixin>() {
    size = 50

    get isTemporaryMenu() {
        return this.viewType == 'mobile' || this.viewType == 'tablet'
    }

    get mobileDrawerState() {
        return this.$store.getters.mobileDrawerState
    }

    set mobileDrawerState(v) {
        this.$store.commit('toggleMobileDrawerState', v)
    }

    // MAIN MENU
    get mainMenu() {
        let mainMenu: any = null
        if (this.isAuthenticated) {
            switch (this.view) {
                case 'project':
                    mainMenu = this.$$projectMenu
                    break
                case 'user':
                    mainMenu = this.userMenu
                    break
                case 'language':
                    mainMenu = true
                    break
            }
        }

        return mainMenu
    }

    get userMenu() {
        return {
            projects: {
                title: this.$t('navigation.projects-list'),
                icon: 'fas fa-list',
                to: { name: 'projects-list' },
                visible: true,
                exact: true,
            },
            settings: {
                title: this.$t('navigation.user-settings'),
                icon: 'fas fa-user-cog',
                to: { name: 'user-settings' },
                visible: true,
            },
            admin: {
                title: this.$t('navigation.admin'),
                icon: 'fas fa-users-cog',
                to: { name: 'company-admin' },
                visible: this.isSuperUser || this.$store.getters.adminCompanies.length > 0,
            },
            translations: {
                title: this.$t('navigation.language-module'),
                icon: 'fas fa-globe-europe',
                to: { path: '/l' },
                visible: this.isSuperUser,
            },
        }
    }

    // SUB MENU
    get hasSubmenu() {
        return Object.values(this.submenu).length > 0
    }

    get submenu() {
        const path = this.$route.path
        let submenu: any = {}
        switch (this.view) {
            case 'project':
                if (path.includes('/s/')) {
                    submenu = this.projectSettingsMenu
                }

                break
            case 'user':
                if (path.includes('/s/')) {
                    submenu = this.userSettingsMenu
                } else if (path.includes('/su/')) {
                    submenu = this.superUserMenu
                } else if (path.includes('/a')) {
                    submenu = this.companyAdminMenu
                }
                break
        }

        return submenu
    }

    get projectSettingsMenu() {
        return {
            general: {
                title: this.$t('project_settings_menu.general'),
                icon: null,
                to: { name: 'project-general-settings' },
                visible: true,
            },
            users: {
                title: this.$t('project_settings_menu.users_settings'),
                icon: null,
                to: { name: 'users-settings' },
                visible: this.hasPermission(this.allPermissions, [
                    'authorization.manage_access',
                    'authorization.delegate_access',
                ]),
            },
            roles: {
                title: this.$t('project_settings_menu.roles_setting'),
                icon: null,
                to: { name: 'roles-setting' },
                visible: this.hasPermission(this.allPermissions, 'authorization.manage_access'),
            },
            modules: {
                title: this.$t('project_settings_menu.modules'),
                icon: null,
                to: { name: 'modules' },
                visible: this.hasPermission(this.allPermissions, 'project.manage.'),
            },

            hse: {
                title: this.$t('navigation.hse-settings'),
                icon: null,
                to: null,
                visible:
                    this.isModuleAccessible('hse') &&
                    this.projects.findIndex((project: any) => {
                        return (
                            project.attributes.constraints.hseBoardDescription.writable ||
                            project.attributes.constraints.hseContacts.writable ||
                            project.attributes.constraints.hseDocuments.writable
                        )
                    }) > -1,
                deletedAt: this.isModuleDeletionAt('hse'),

                open: this.$route.path.includes('hse-settings'),
                sub: {
                    qr: {
                        title: this.$t('navigation.hse-qr-settings'),
                        icon: null,
                        to: {
                            name: 'hse-qr-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    info: {
                        title: this.$t('navigation.hse-info-settings'),
                        icon: null,
                        to: {
                            name: 'hse-info-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    contacts: {
                        title: this.$t('navigation.hse-contacts-settings'),
                        icon: null,
                        to: {
                            name: 'hse-contacts-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    documents: {
                        title: this.$t('navigation.hse-documents-settings'),
                        icon: null,
                        to: {
                            name: 'hse-documents-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                },
            },

            psi: {
                title: this.$t('navigation.psi-settings'),
                icon: null,
                to: null,
                visible:
                    this.isModuleAccessible('psi') &&
                    this.hasPermission(this.allPermissions, 'psi.admin'),
                deletedAt: this.isModuleDeletionAt('psi'),
                open: this.$route.path.includes('psi'),

                sub: {
                    qr: {
                        title: this.$t('navigation.psi-qr-settings'),
                        icon: null,
                        to: {
                            name: 'psi-qr-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    info: {
                        title: this.$t('navigation.psi-forms-settings'),
                        icon: null,
                        to: {
                            name: 'psi-all-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                },
            },
            accessControl: {
                title: this.$t('project_menu.access_control'),
                icon: null,
                to: null,
                visible:
                    this.isModuleAccessible('access') &&
                    this.hasPermission(this.allPermissions, 'access.admin'),
                deletedAt: this.isModuleDeletionAt('access'),
                open: this.$route.path.includes('ac'),

                sub: {
                    general: {
                        title: this.$t('project_settings_menu.general'),
                        icon: null,
                        to: {
                            name: 'access-settings-general',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    groups: {
                        title: this.$t('project_settings_menu.groups'),
                        icon: null,
                        to: {
                            name: 'access-settings-groups',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    readers: {
                        title: this.$t('project_settings_menu.readers'),
                        icon: null,
                        to: {
                            name: 'access-settings-readers',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    rules: {
                        title: this.$t('project_settings_menu.rules'),
                        icon: null,
                        to: {
                            name: 'access-settings-rules',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                },
            },
            courses: {
                title: this.$t('project_menu.course'),
                visible:
                    this.isModuleAccessible('course') &&
                    this.hasPermission(this.allPermissions, 'course.admin'),

                open: this.$route.name?.includes('courses-settings'),
                sub: {
                    general: {
                        title: this.$t('project_settings_menu.general'),
                        visible:
                            this.isModuleAccessible('course') &&
                            this.hasPermission(this.allPermissions, 'course.admin'),
                        to: {
                            name: 'courses-settings-general',
                            params: { projectId: this.$route.params.projectId },
                        },
                    },
                    items: {
                        title: this.$t('project_settings_menu.all_courses'),
                        visible:
                            this.isModuleAccessible('course') &&
                            this.hasPermission(this.allPermissions, 'course.admin'),
                        to: {
                            name: 'courses-settings-all-courses',
                            params: { projectId: this.$route.params.projectId },
                        },
                    },
                },
            },
            observation: {
                title: this.$t('project_settings_menu.observations'),
                icon: null,
                to: null,
                visible:
                    this.isModuleAccessible('observation') &&
                    this.hasPermission(this.allPermissions, 'observation.admin'),
                deletedAt: this.isModuleDeletionAt('observation'),

                open: this.$route.path.includes('observations-settings'),
                sub: {
                    general: {
                        title: this.$t('project_settings_menu.observation_general'),
                        icon: null,
                        to: {
                            name: 'general-observations-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    location: {
                        title: this.$t('project_settings_menu.locations'),
                        icon: null,
                        to: { name: 'location-settings' },
                        visible: this.hasPermission(
                            this.allPermissions,
                            'project.manage_locations'
                        ),
                    },
                    locationDrawings: {
                        title: this.$t("project_settings_menu['project.locationDrawing']"),
                        icon: null,
                        to: { name: 'location-drawing-settings' },
                        visible: this.hasPermission(
                            this.allPermissions,
                            'project.manage_locations'
                        ),
                    },
                    categories: {
                        title: this.$t('project_settings_menu.observation_categories'),
                        icon: null,
                        to: {
                            name: 'categories-observations-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    causes: {
                        title: this.$t('project_settings_menu.observation_causes'),
                        icon: null,
                        to: {
                            name: 'causes-observations-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                    responsibleUsers: {
                        title: this.$t('project_settings_menu.observation_responsible-users'),
                        icon: null,
                        to: {
                            name: 'responsible-users-settings',
                            params: { projectId: this.$route.params.projectId },
                        },
                        visible: true,
                    },
                },
            },
            contractors: {
                title: this.$t('project_menu.contractors'),
                to: null,
                visible:
                    this.isModuleAccessible('contractor') &&
                    this.hasPermission(this.allPermissions, ['contractor.admin']),
                deletedAt: this.isModuleDeletionAt('contractor'),

                open: this.$route.path.includes('ch'),
                sub: {
                    general: {
                        title: this.$t('project_settings_menu.general'),
                        to: { name: 'general-contractors-settings' },
                    },
                    forms: {
                        title: this.$t('project_menu.contractor_forms'),
                        to: { name: 'contractors-forms' },
                    },
                    ...(this.isModuleActive('personnel')
                        ? {
                              workAlert: {
                                  title: this.$t('project_menu.contractor_work_alerts'),
                                  to: { name: 'alert-contractors-settings' },
                              },
                          }
                        : {}),
                },
            },
        }
    }

    get userSettingsMenu() {
        return {
            general: {
                title: this.$t('navigation.user_general_settings'),
                icon: null,
                to: { name: 'general-settings' },
                visible: true,
            },
            contact: {
                title: this.$t('navigation.user_contacts_settings'),
                icon: null,
                to: { name: 'contact-settings' },
                visible: true,
            },
            notifications: {
                title: this.$t('navigation.user_notifications_settings'),
                icon: null,
                to: { name: 'notification-settings' },
                visible: true,
            },
            password: {
                title: this.$t('navigation.password-settings'),
                icon: null,
                to: { name: 'password-settings' },
                visible: true,
            },
        }
    }

    get superUserMenu() {
        return {
            user: {
                title: this.$t('navigation.superuser_manage_user'),
                icon: null,
                to: { name: 'superuser_manage_user' },
                visible: true,
            },
            project: {
                title: this.$t('navigation.superuser_manage_project'),
                icon: null,
                to: { name: 'superuser_manage_project' },
                visible: true,
            },
        }
    }

    get companyAdminMenu() {
        return {
            projects: {
                title: this.$t("navigation['admin.projects']"),
                icon: null,
                to: { name: 'admin.projects' },
                visible: true,
            },
            admins: {
                title: this.$t("navigation['admin.admins']"),
                icon: null,
                to: { name: 'admin.admins' },
                visible: true,
            },
            employees: {
                title: this.$t("navigation['admin.employees']"),
                icon: null,
                to: { name: 'admin.employees' },
                visible: true,
            },
            workers: {
                title: this.$t("navigation['admin.projectsUsers']"),
                icon: null,
                to: { name: 'admin.projectsUsers' },
                visible: true,
            },
            cardReaders: {
                title: this.$t("navigation['admin.cardReaders']"),
                icon: null,
                to: { name: 'manage_card_readers' },
                visible: true,
            },
            user: {
                title: this.$t('navigation.manage_users'),
                icon: null,
                to: { name: 'manage_users' },
                visible: this.isSuperUser,
            },
        }
    }
    // USER VAR
    get currentUser() {
        return this.$store.getters.user
    }

    get isSuperUser() {
        return this.currentUser?.attributes?.isSuperuser
    }

    // PROJECT VAR
    get group() {
        return this.view == 'project' && this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get projects() {
        return Object.values(this.$store.getters.projects)
    }

    get hasByggekortleser() {
        return Boolean(this.$$project?.attributes?.bklrId)
    }
}
